import { blueCheckbox } from "reports/constants/colors";
import styled from "styled-components/macro";

export const ButtonStyles = styled.div<{ leftPaddingPx?: number }>`
  display: flex;
  justify-content: flex-end;
  font-family: "GothamLight";

  a {
    text-decoration: none;
  }

  button {
    border: 1px solid ${blueCheckbox};
    color: ${blueCheckbox};
    text-transform: none;
  }
`;
